import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'
import GetCricketTeamsList from '../../Services/Queries/GetCricketTeamsList'
import AwsConfig from '../../Config/AwsConfig'
import ListFeaturedMatches from '../../Services/Queries/ListFeaturedMatches'
import ListAssociationFeaturedTournaments from '../../Services/Queries/ListAssociationFeaturedTournaments'
import ListAssociations from '../../Services/Queries/ListAssociations'
import { DefinedPermissions } from '../Constants/Permissions'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { MatchData } from '../Data/StaticData'
import { Auth } from 'aws-amplify'
export default class LiveUpdates extends Component {
  imageTemplateTypes = []
  constructor(props) {
    super(props)
    this.state = {
      liveCricketTitle: '',
      liveCricketDescription: '',
      chooseFeaturedMatchModalVisible: false,
      teamsList: [],
      selectedFeaturedMatch: '',
      featuredMatches: [],
      selectedIcons: [],
      selectedIconObjArr: [],
      chooseIconsModalVisible: false,
      selectedFeaturedMatchData: {},
      loggedInUserPermissions: [],
      chooseAssociationModalVisible: false,
      chooseTournamentModalVisible: false,
      selectedTypes: [],
      associationsList: [],
      selectedAssociation: {},
      associationTournamentsList: [],
      selectedTournament: {},
      matchInfo: MatchData
    }
    // this.presser = this.presser.bind(this)
  }

  selectFeaturedMatch = (index) => {
    const key = this.state.featuredMatches[index].key
    const selectedFeaturedMatchData = this.state.featuredMatches[index]
    console.log(this.state.featuredMatches[index].key, 'index=======================')
    this.setState({ selectedFeaturedMatch: index, selectedFeaturedMatchData })
    this.props.updateInParent('matchKey', key, 'liveCricketScore')
    this.props.handleFeaturedMatchKey(key)
    let selectedFeaturedMatchName = ''
    if (this.state.featuredMatches[index]) {
      selectedFeaturedMatchName = this.state.featuredMatches[index].name
    }
    const teamA = selectedFeaturedMatchData.teams.a.code
    const teamB = selectedFeaturedMatchData.teams.b.code
    const teamsShortCodes = [teamA, teamB]
    this.props.handleTeamsShortCodes(teamsShortCodes)
    this.props.updateInParent('matchTitle', selectedFeaturedMatchName, 'liveCricketScore')
    this.props.updateInParent(
      `liveCricketTitle_${this.props.contentSelectedLangVal}`,
      selectedFeaturedMatchName,
      'liveCricketScore'
    )
  }
  updateData = async () => {
    const { editContent, liveCricketDetails, contentSelectedLangVal, associationKey,
      tournamentKey } = this.props
    let parsedData = []
    console.log(this.props.matchKey, 'matchKey')
    console.log(this.state.featuredMatches, 'featuredMatches')
    const selectedFeaturedMatchIndex = this.state.featuredMatches.findIndex((item, index) => {
      return item.key == this.props.matchKey
    })
    const selectedAssociationIndex = this.state.associationsList.findIndex((item, index) => {
      return item.key == associationKey
    })
    const selectedAssociation = this.state.associationsList[selectedAssociationIndex]
    const input = { associationKey: selectedAssociation ? selectedAssociation.key : '' }
    let selectedTournament = {}
    const listAssociationsPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['listAssociationsPermission']
    )
    let associationTournamentsResponse = []
    if (listAssociationsPermission) {
      associationTournamentsResponse = await ListAssociationFeaturedTournaments(input)
    }
    console.log(associationTournamentsResponse, 'associationTournamentsResponse')
    if (associationTournamentsResponse.tournamentsInfo) {
      associationTournamentsResponse = JSON.parse(associationTournamentsResponse.tournamentsInfo)
      console.log(associationTournamentsResponse, 'associationTournamentsResponse=============')
      const selectedTournamentIndex = associationTournamentsResponse.findIndex((item, index) => {
        return item.key == this.props.tournamentKey
      })
      selectedTournament = associationTournamentsResponse[selectedTournamentIndex]
    }
    const listFeaturedMatchesPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['listFeaturedMatchesPermission']
    )
    if (selectedTournament && listFeaturedMatchesPermission) {
      if (this.props.tournamentKey) {
        const input = { tournamentKey: this.props.tournamentKey }
        console.log(input.tournamentKey, input, "=============ListFeaturedMatchesInput")
        const featuredMatchesResponse = await ListFeaturedMatches(input)
        if (featuredMatchesResponse.matchesInfo) {
          parsedData = JSON.parse(featuredMatchesResponse.matchesInfo)
          console.log(parsedData, 'ListFeaturedMatchesResponse=============')
        }
      }
    }
    let indexes = []
    liveCricketDetails.liveCricketImages &&
      liveCricketDetails.liveCricketImages.length > 0 &&
      liveCricketDetails.liveCricketImages.map((imageItem, imageIndex) => {
        const selectedImagesIndexes = this.state.teamsList.findIndex((item, index) => {
          return item.teamImage == imageItem.image || item.teamLogo == imageItem.image
        })
        indexes.push(selectedImagesIndexes)
      })

    this.setState({
      liveCricketTitle: liveCricketDetails[`liveCricketTitle_${contentSelectedLangVal}`],
      liveCricketDescription:
        liveCricketDetails[`liveCricketDescription_${contentSelectedLangVal}`],
      liveCricketImages: liveCricketDetails.liveCricketImages
        ? liveCricketDetails.liveCricketImages
        : [],
      selectedIconObjArr: liveCricketDetails.liveCricketImages
        ? liveCricketDetails.liveCricketImages
        : [],
      selectedFeaturedMatch: selectedFeaturedMatchIndex,
      selectedFeaturedMatchData: this.state.featuredMatches[selectedFeaturedMatchIndex],
      selectedIcons: liveCricketDetails.liveCricketImages ? indexes : [],
      selectedAssociation: selectedAssociation,
      selectedTournament: selectedTournament,
      featuredMatches: parsedData,
    })
  }
  componentDidMount = async () => {
    let associationsResponse = []
    const response = await GetCricketTeamsList()
    console.log(response, 'response=============')

    const permissionInput = {
      mobileNumber: Auth.user.attributes.phone_number,
    }
    console.log(permissionInput, 'permissionInput')
    const userPermissions = await GetUserPermissions(permissionInput)
    console.log(userPermissions, 'userPermissions')
    let permissions = []
    let permissionsArr = []
    if (userPermissions && userPermissions.userRolesAndPermissions) {
      userPermissions.userRolesAndPermissions.map((item) => {
        permissions.push(...item.permissions)
      })
      permissions.map((permission) => {
        permissionsArr.push(permission.name)
      })
    }
    console.log(permissionsArr, 'permissionsArr')

    let list = []
    let parsedData = []
    const listFeaturedMatchesPermission = permissionsArr.includes(
      DefinedPermissions['listFeaturedMatchesPermission']
    )
    const listAssociationsPermission = permissionsArr.includes(
      DefinedPermissions['listAssociationsPermission']
    )
    // if (listAssociationsPermission) {
    //   associationsResponse = await ListAssociations()
    //   console.log(associationsResponse, 'associationsResponse')

    //   if (associationsResponse.associationsInfo) {
    //     associationsResponse = JSON.parse(associationsResponse.associationsInfo)
    //     console.log(associationsResponse, 'associationsResponse=============')
    //   }
    // }

    this.setState({
      teamsList: list,
      loggedInUserPermissions: permissionsArr,
      // associationsList: associationsResponse,
    })
    if (this.props.editContent) {
      await this.updateData()
    }
  }
  listAssociationsService = async () => {
    const { loggedInUserPermissions } = this.state
    const listAssociationsPermission = loggedInUserPermissions.includes(
      DefinedPermissions['listAssociationsPermission']
    )
    let associationsResponse = []
    if (listAssociationsPermission) {
      associationsResponse = await ListAssociations()
      console.log(associationsResponse, 'associationsResponse')

      if (associationsResponse.associationsInfo) {
        associationsResponse = JSON.parse(associationsResponse.associationsInfo)
        console.log(associationsResponse, 'associationsResponse=============')
      }
    }
    this.setState({
      associationsList: associationsResponse,
      chooseAssociationModalVisible: true
    })
    if (this.props.editContent) {
      await this.updateData()
    }
  }

  componentDidUpdate = async (prevProps) => {
    if (prevProps.contentSelectedLangVal != this.props.contentSelectedLangVal) {
      const { editContent, liveCricketDetails, contentSelectedLangVal } = this.props
      console.log(liveCricketDetails.liveCricketImages, 'liveCricketDetails.liveCricketImages')
      if (editContent) {
        await this.updateData()
      }
    }
  }
  getFormattedDate = (date) => {
    var dd = date.getDate()
    var mm = date.getMonth() + 1

    var yyyy = date.getFullYear()
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    var formattedDate = dd + '/' + mm + '/' + yyyy
    var hh = date.getHours()
    var m = date.getMinutes()
    var d = 'AM'
    var h = hh
    if (h >= 12) {
      h = hh - 12
      d = 'PM'
    }
    if (h == 0) {
      h = 12
    }
    m = m < 10 ? '0' + m : m
    const formattedTime = h + ':' + m + ' ' + d
    return formattedDate + ' ' + formattedTime
  }
  selectAssociation = (association) => {
    this.setState({ selectedAssociation: association, selectedTournament: {} })
    this.selectTournament({})
    this.props.handleSelectedAssociation(association.key)
    this.props.updateInParent('associationKey', association.key, 'liveCricketScore')
  }
  selectTournament = (tournament) => {
    this.setState({ selectedTournament: tournament })
    const tournamentKey = tournament && tournament.key ? tournament.key : ''
    this.props.handleSelectedTournament(tournamentKey)
    this.props.updateInParent('tournamentKey', tournamentKey, 'liveCricketScore')
  }
  openTournamentsListModal = async () => {
    const input = { associationKey: this.state.selectedAssociation.key }
    // console.log(input, 'inputtt')
    let associationTournamentsResponse = await ListAssociationFeaturedTournaments(input)
    console.log(associationTournamentsResponse, 'associationTournamentsResponse')
    if (associationTournamentsResponse.tournamentsInfo) {
      associationTournamentsResponse = JSON.parse(associationTournamentsResponse.tournamentsInfo)
      console.log(associationTournamentsResponse, 'associationTournamentsResponse=============')
      this.setState({ associationTournamentsList: associationTournamentsResponse })
    }
    this.setState({ chooseTournamentModalVisible: true })
  }
  openFeaturedMatchesModal = async () => {
    let parsedData = []
    const input = { tournamentKey: this.state.selectedTournament.key }
    console.log(input, 'inputtt=========================')
    let featuredMatchesResponse = await ListFeaturedMatches(input)
    console.log(featuredMatchesResponse, 'featuredMatchesResponse')
    if (featuredMatchesResponse.matchesInfo) {
      parsedData = JSON.parse(featuredMatchesResponse.matchesInfo)
      this.setState({ featuredMatches: parsedData, })
    }
    this.setState({ chooseFeaturedMatchModalVisible: true })
  }
  renderAssociationsListModal = () => {
    const cdnurl = AwsConfig.cdn_url

    return (
      <Modal
        show={this.state.chooseAssociationModalVisible}
        onHide={() => this.setState({ chooseAssociationModalVisible: false })}
      >
        <Modal.Body>
          <div className='associationsList'>
            {this.state.associationsList.map((association, associationIndex) => {
              const bgColor =
                this.state.selectedAssociation &&
                  this.state.selectedAssociation.name != '' &&
                  this.state.selectedAssociation.name == association.name
                  ? '#e6e6e6'
                  : ''
              return (
                <div
                  class='card p-3 teamCard'
                  style={{ backgroundColor: bgColor }}
                  onClick={() => this.selectAssociation(association)}
                >
                  <text className='mt-2' style={{ fontSize: 10 }}>
                    {association.name}
                  </text>
                </div>
              )
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.setState({ chooseAssociationModalVisible: false })}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
  renderTournamentsListModal = () => {
    const cdnurl = AwsConfig.cdn_url

    return (
      <Modal
        show={this.state.chooseTournamentModalVisible}
        onHide={() => this.setState({ chooseTournamentModalVisible: false })}
      >
        <Modal.Body>
          <div className='associationsList'>
            {this.state.associationTournamentsList.map((tournament, tournamentIndex) => {
              const bgColor =
                this.state.selectedTournament &&
                  this.state.selectedTournament.name != '' &&
                  this.state.selectedTournament.name == tournament.name
                  ? '#e6e6e6'
                  : ''
              return (
                <div
                  class='card p-3 teamCard'
                  style={{ backgroundColor: bgColor }}
                  onClick={() => this.selectTournament(tournament)}
                >
                  <text className='mt-2' style={{ fontSize: 10 }}>
                    {tournament.name}
                  </text>
                </div>
              )
            })}
            {this.state.associationTournamentsList.length == 0 ? (
              <text>No Tournaments Available...Choose Other Association...</text>
            ) : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.setState({ chooseTournamentModalVisible: false })}>Ok</Button>
        </Modal.Footer>
      </Modal>
    )
  }
  renderFeaturedMatchesListModal = () => {
    return (
      <Modal
        show={this.state.chooseFeaturedMatchModalVisible}
        onHide={() => this.setState({ chooseFeaturedMatchModalVisible: false })}
      >
        <Modal.Body>
          <div className='teamsList'>
            {this.state.featuredMatches.map((match, matchIndex) => {
              const bgColor =
                this.state.selectedFeaturedMatch != '' &&
                  this.state.selectedFeaturedMatch == matchIndex
                  ? '#e6e6e6'
                  : ''

              return (
                <div
                  class='card  matchCard'
                  style={{ backgroundColor: bgColor }}
                  onClick={() => this.selectFeaturedMatch(matchIndex)}
                >
                  <div class='card-body'>
                    <h5 class='card-title cardTitle'>{match.name}</h5>
                    <p class='card-subtitle text-muted cardSubTitle'>{match.title}</p>
                  </div>
                  <p class='card-subtitle text-muted cardSubTitle'>
                    {'Status'} : {match.status}
                  </p>
                  <p class='card-subtitle text-muted cardSubTitle'>
                    {' Start Date'} : {this.getFormattedDate(new Date(match.start_at * 1000))}
                  </p>
                </div>
              )
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.setState({ chooseFeaturedMatchModalVisible: false })}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  render() {
    const { data } = this.props
    const cdnurl = AwsConfig.cdn_url

    const { liveCricketTitle, liveCricketDescription, selectedFeaturedMatchData } = this.state
    console.log(this.state.selectedFeaturedMatch, 'selectedFeaturedMatch')
    let selectedFeaturedMatchName = ''
    if (this.state.featuredMatches[this.state.selectedFeaturedMatch]) {
      selectedFeaturedMatchName = this.state.featuredMatches[this.state.selectedFeaturedMatch].name
    }
    console.log(selectedFeaturedMatchData, 'selectedFeaturedMatchData')
    const listFeaturedMatchesPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['listFeaturedMatchesPermission']
    )
    const listAssociationsPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['listAssociationsPermission']
    )
    const listAssociationFeaturedMatchesPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions['listAssociationFeaturedMatchesPermission']
    )
    return (
      <div class='row col-md-10'>
        {/* <GeneralOptions data={this.state} handleChangeLanguage={this.handleChangeLanguage} /> */}
        <details>
          <summary>Live Updates</summary>
          <div class='content'>
            {this.renderAssociationsListModal()}
            {this.renderTournamentsListModal()}
            {this.renderFeaturedMatchesListModal()}
            {listAssociationsPermission ? (
              <div>
                <div class='form-group'>
                  <label for='selectedAssociation'>Choose Association</label>
                  <input
                    disabled={this.props.editContent ? true : false}
                    type='select'
                    value={
                      this.state.selectedAssociation && this.state.selectedAssociation.name
                        ? this.state.selectedAssociation.name
                        : ''
                    }
                    class='form-control'
                    id='selectedAssociation'
                    placeholder='Choose Association'
                    onClick={() => this.listAssociationsService()}
                  />
                </div>
                {!this.state.selectedAssociation.name ? (
                  <text for='text' style={{ color: 'red', fontSize: 10 }}>
                    Please choose an association
                  </text>
                ) : null}
              </div>
            ) : (
              <div>
                <p class='card-subtitle text-muted cardSubTitle'>
                  {'Selected Association'} :{' '}
                  {this.state.selectedAssociation && this.state.selectedAssociation.name
                    ? this.state.selectedAssociation.name
                    : this.props.associationKey}
                </p>
              </div>
            )}
            <div className='associationslist'>
              {this.state.matchInfo.map((match, index) => {
                const bgColor =
                  this.state.selectedAssociation &&
                    this.state.selectedAssociation.name != '' &&
                    this.state.selectedAssociation.name == match.name
                    ? '#e6e6e6'
                    : ''
                return (
                  <div
                    class='card p-3 teamCard'
                    style={{ backgroundColor: bgColor }}
                    onClick={() => this.selectAssociation(match)}
                  >
                    <text className='mt-2' style={{ fontSize: 10 }}>
                      {match.name}
                    </text>
                  </div>
                )
              })}
            </div>

            {
              listAssociationFeaturedMatchesPermission ? (
                // && this.state.selectedAssociation &&
                // this.state.selectedAssociation.name ? (
                <div>
                  <div class='form-group'>
                    <label for='selectedTournament'>Choose Tournament</label>
                    <input
                      disabled={this.props.editContent ? true : false}
                      type='select'
                      value={
                        this.state.selectedTournament && this.state.selectedTournament.name
                          ? this.state.selectedTournament.name
                          : ''
                      }
                      class='form-control'
                      id='selectedTournament'
                      placeholder='Choose Tournament'
                      onClick={() => this.openTournamentsListModal()}
                    />
                  </div>
                  {!this.state.selectedTournament.name ? (
                    <text for='text' style={{ color: 'red', fontSize: 10 }}>
                      Please choose a tournament
                    </text>
                  ) : null}
                </div>
              ) : (
                <div>
                  <p class='card-subtitle text-muted cardSubTitle'>
                    {'Selected Tournament'} :{' '}
                    {this.state.selectedTournament && this.state.selectedTournament.name
                      ? this.state.selectedTournament.name
                      : this.props.tournamentKey}
                  </p>
                </div>
              )}
            {listFeaturedMatchesPermission ? (
              // && this.state.selectedTournament && this.state.selectedTournament.name ? (
              <div>
                <div class='form-group'>
                  <label for='selectedFeaturedMatch'>Choose Featured Match</label>
                  <input
                    disabled={this.props.SK == 'm#published' ? true : false}
                    type='select'
                    class='form-control'
                    id='selectedFeaturedMatch'
                    placeholder='Choose Featured Match'
                    value={selectedFeaturedMatchName}
                    // onClick={() => this.setState({ chooseFeaturedMatchModalVisible: true })}
                    onClick={() => this.openFeaturedMatchesModal()}
                  />
                </div>
              </div>
            ) : null}
            {selectedFeaturedMatchName ? (
              <div>
                <p class='card-subtitle text-muted cardSubTitle'>
                  {'Status'} : {selectedFeaturedMatchData.status}
                </p>
                <p class='card-subtitle text-muted cardSubTitle'>
                  {' Start Date'} :{' '}
                  {this.getFormattedDate(new Date(selectedFeaturedMatchData.start_at * 1000))}
                </p>
              </div>
            ) : null}
          </div>
        </details>
      </div>
    )
  }
}
